module.exports = __webpack_public_path__ + "img/pawprint.af5f0838.svg";